import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "quick-replies" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "reply-title" }

import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'quick-replies',
  props: {
  messageColour: {
    type: String,
    required: true,
  },
  actions: {
    type: Array as PropType<string[]>,
    required: true,
  },
},
  emits: ["sendQuickReply"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

function getStyle() {
  return {
    border: `1px solid ${props.messageColour}`,
    color: props.messageColour,
  };
}

function sendQuickReply(reply: string): void {
  emit('sendQuickReply', {
    text: reply,
    isQuickReplyResponse: true,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actions, (action, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle(getStyle()),
        onClick: ($event: any) => (sendQuickReply(action)),
        class: "reply"
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(action), 1)
      ], 12, _hoisted_2))
    }), 128))
  ]))
}
}

})